import script from "./CurtainLinkedLightsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CurtainLinkedLightsPage.vue?vue&type=script&setup=true&lang=js"

import "./CurtainLinkedLightsPage.vue?vue&type=style&index=0&id=7bc7655e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc7655e"]])

export default __exports__